
import { Component, mixins } from 'nuxt-property-decorator';
import WebsiteHeaderMixin from './WebsiteHeaderMixin';
import { HeaderSectionImageSide } from '../../../services';

@Component
export default class WebsiteHeaderSplit extends mixins(WebsiteHeaderMixin) {
  get rootClassNames(): Record<string, boolean> {
    return {
      '-image-left': this.headerSection.imageSide === HeaderSectionImageSide.Left,
    };
  }
}
